/**
 * 비디오 썸네일 → iframe autoplay 컨트롤러.
 *
 * [data-fw-video-thumb] 클릭 시 인접한 [data-fw-video-frame] iframe 의 src 에
 * autoplay=1 쿼리를 추가하고 표시. 썸네일은 display:none 으로 숨김.
 *
 * autoplay 정책(브라우저) 우회 목적 — 초기에는 iframe 이 숨겨져 있고
 * 사용자 제스처(클릭) 후에만 재생 시작.
 *
 * iframe 탐색 규칙: 같은 video-wrapper 내부 우선, 없으면 전체 document 첫 번째.
 */
export const VIDEO_THUMB_CONTROLLER_SCRIPT = `
<script data-fw-video-thumb-controller>
(function () {
  function findFrame(thumb) {
    var wrapper = thumb.closest('.video-wrapper') || thumb.parentElement;
    if (wrapper) {
      var f = wrapper.querySelector('[data-fw-video-frame]');
      if (f) return f;
    }
    return document.querySelector('[data-fw-video-frame]');
  }
  function init() {
    var thumbs = document.querySelectorAll('[data-fw-video-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      var thumb = thumbs[i];
      if (thumb.dataset.fwVideoInit) continue;
      thumb.dataset.fwVideoInit = '1';
      thumb.addEventListener('click', (function (t) {
        return function () {
          var frame = findFrame(t);
          if (!frame) return;
          var src = frame.getAttribute('src') || '';
          if (src.indexOf('autoplay=1') === -1) {
            var sep = src.indexOf('?') !== -1 ? '&' : '?';
            frame.setAttribute('src', src + sep + 'autoplay=1&mute=0');
          }
          frame.style.display = '';
          t.style.display = 'none';
        };
      })(thumb));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=video-thumb.js.map